import { Member } from '@nextforce/api'
import { ListItem, Text, makeStyles } from '@rneui/themed'
import { font } from 'app/theme'
import { t } from 'app/i18l'
import moment from 'moment'
import React from 'react'
import { View } from 'react-native'
import { CheckBox } from 'shared/components/check_box'
import { UserAvatar } from 'shared/components/user/user_avatar'

interface Props {
  member: Member
  readAt?: Date
  checked?: boolean
  disabled?: boolean
  selectable?: boolean
  showAdminStatus?: boolean
  disabledReason?: string
  onPress?(member: Member): void
  bottomDivider?: boolean
}

export function MemberCard({
  member,
  readAt,
  checked,
  disabled,
  showAdminStatus,
  selectable,
  onPress,
  bottomDivider = true,
  disabledReason,
}: Props) {
  const styles = useStyles({ disabled })

  return (
    <ListItem
      disabled={disabled}
      onPress={() => onPress?.(member)}
      bottomDivider={bottomDivider}
    >
      <UserAvatar user={member} size="medium" showAvatarIfNoPhone={true} />
      <ListItem.Content style={styles.memberDetailsContainer}>
        <View style={styles.titleContainer}>
          <ListItem.Title style={[styles.title]}>
            {`${member.firstName} ${member.lastName}`}
          </ListItem.Title>
          {member.jobTitle ? (
            <Text style={[styles.subtitle]}>{member.jobTitle}</Text>
          ) : null}
        </View>
        <ListItem.Title style={styles.title}>
          {showAdminStatus && member.isAdmin ? t('admin') : ''}
        </ListItem.Title>
        {!disabled && readAt && (
          <ListItem.Subtitle style={styles.subtitle}>
            {moment(readAt).format('lll')}
          </ListItem.Subtitle>
        )}
        {disabled && checked && (
          <ListItem.Subtitle style={styles.subtitle}>
            {disabledReason || t('alreadyAMember')}
          </ListItem.Subtitle>
        )}
      </ListItem.Content>
      {selectable && (
        <CheckBox
          checked={checked}
          disabled={disabled}
          onPress={() => onPress?.(member)}
        />
      )}
    </ListItem>
  )
}

const useStyles = makeStyles((theme, { disabled }: { disabled?: boolean }) => ({
  title: disabled
    ? {
        color: theme.colors?.grey3,
      }
    : {},
  subtitle: disabled
    ? {
        color: theme.colors?.grey3,
        fontFamily: font.italic,
      }
    : {
        color: theme.colors?.grey3,
      },
  memberDetailsContainer: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  titleContainer: {
    flex: 1,
    justifyContent: 'center',
    textAlignVertical: 'center',
  },
}))
